import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { Switch, BrowserRouter as Router } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// Import Routes all every
import { authProtectedRoutes, publicRoutes, privateRoutes } from "./routes";

// Import all middleware
import Authmiddleware from "./routes/route";

// layouts Format
import VerticalLayout from "./components/VerticalLayout";
import HorizontalLayout from "./components/HorizontalLayout";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import "./App.scss";
import Page404 from "utils/404";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { VERIFY_AUTH_ON_LOAD } from "store/auth/login/actionTypes";

const App = props => {
    const dispatch = useDispatch();
      useEffect(() => {
    dispatch({ type: VERIFY_AUTH_ON_LOAD });
  }, [dispatch]);
  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();

  return (
    <React.Fragment>
      <Router>
        <Switch>
          {publicRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              isPrivate={false}
              exact
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              isPrivate={false}
              allowedRoles={route.allowedRoles || []}
              exact
            />
          ))}
          {privateRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              isPrivate={true}
              exact
            />
          ))}
          <Route path="*" exact={true} component={Page404} />
        </Switch>
      </Router>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
